module.exports = __webpack_public_path__ + "static/scale-model-of-fayetteville-north-carolina-4558bf5ca49fec20a55cba5f7e6616ff.png";